/*
 * @Descripttion:
 * @version: 负责初始化和情况本地store
 * @Author: limin
 * @Date: 2021-03-23 18:18:20
 * @LastEditors: limin
 * @LastEditTime: 2021-04-14 20:45:16
 */

const state = {

}
const getters = {

}
const mutations = {
  setTheFirstLink(state, url) {
    state.theFirstLink = url
  }
}

const actions = {
  /**
   * 系统初始化
   * 1. 获取URL参数,保存到common store 所有 url 参数 都保存到 common=>sysCfg
   * 2. 以是否有userId 和sessionId 判断是否已登录
   * 3. 登录的情况下 则获取该用户的地址(如果在系统内唤起登录 参照onLoginBack)
   * @param {*} param0
   * @param {*} params
   * @returns
   */
  init({ dispatch }) {
    return new Promise((resolve) => {
      dispatch('common/initSysConfig', {}, { root: true }).then(cfg=>{
        cfg && dispatch("address/getAllAddress", {}, { root: true });
        resolve()
      });
    });
  },
  /**
   * 系统内唤起登录后的回调
   * 1.将登录后的sessionId,userId 更新至common=>sysCfg
   * 2. 获取该用户的地址
   * @param {*} param0
   * @param {*} param1
   */
  onLoginBack({ dispatch }, {sessionId,userId}) {
    return new Promise((resolve) => {
      dispatch('common/setSysConfig', {sessionId,userId}, { root: true }).then(()=>{
        dispatch("address/getAllAddress", {}, { root: true });
        resolve()
      });
    });
  },
  /**
   * 清空系统信息(store)
   * 1. 清空 地址
   * 2. 重置 sessionId,userId 为空
   * @param {*} param0
   * @returns
   */
  clear({ dispatch }) {
    return new Promise((resolve) => {
      dispatch('common/setSysConfig', {sessionId: '', userId: ''}, { root: true });
      dispatch("address/clearLocalAddress", {}, { root: true });
      resolve()
    });
  }
}

export default {
  namespaced: true, // 添加命名空间
  state,
  getters,
  mutations,
  actions
}
